import React from 'react';
import PropTypes from 'prop-types';
import { useIsMobile } from '../../hooks/useIsMobile';
import Details from './Details';
import Image from './Image';
import ContactActions from './ContactActions';
import ModalCard from './ModalCard';
import { StaffMemberShape } from '../../global-constants';

const HCard = ({ staffMember, delayLoadImage }) => {
	const { isMobile } = useIsMobile();
	const { name, photo, department } = staffMember;

	// Ensures the card, which is a flex child, takes up all available vertical and horizontal space
	// while setting specific width values for the card itself and the image container within it.
	const cardWrapperClass =
		'flex-grow-1 staff-card-horizontal h-100 box box-border';

	const getDetailsClasses = () => {
		// Determine value for Bootstraps horizontal padding utility class
		const xPadding = isMobile ? '4' : '5';

		// Causes the flex children in the <Details /> component to spread out towards the edges of the card,
		// and allows the buttons to wrap as cards ajdust responsively to smaller viewports
		const containerCls = [
			'flex-grow-1',
			`pr-${xPadding}`,
			'py-4',
			'd-flex',
			'flex-column'
		];

		if (!isMobile) {
			// Adding some padding left here since the image container will take care of adding the rest.
			// Padding does NOT collapse, like vertical margin does, and instead is cummulative.
			containerCls.push('pl-3');
		}

		return containerCls.join(' ');
	};

	return (
		<div className={`${cardWrapperClass} d-flex`} data-testid="hCard">
			<div className="img-container" data-testid="hCardImgContainer">
				<Image
					name={name}
					department={department}
					url={photo}
					delayLoadImage={delayLoadImage}
					isWithinModal={false}
				/>
			</div>
			<div className={getDetailsClasses()}>
				<Details isWithinModal={false} staffMember={staffMember} />
				<ContactActions staffMember={staffMember} isWithinModal={false}>
					<ModalCard staffMember={staffMember} />
				</ContactActions>
			</div>
		</div>
	);
};

HCard.propTypes = {
	staffMember: PropTypes.shape(StaffMemberShape).isRequired,
	delayLoadImage: PropTypes.bool.isRequired
};

export default HCard;
